"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Pin = _interopRequireDefault(require("@rsuite/icon-font/lib/status/Pin"));

// Generated by script, don't edit it please.
var Pin = (0, _createSvgIcon["default"])({
  as: _Pin["default"],
  ariaLabel: 'pin',
  category: 'status',
  displayName: 'Pin'
});
var _default = Pin;
exports["default"] = _default;
module.exports = exports.default;